import { useMutation } from "@tanstack/react-query";

import { signIn } from "../../services/auth";

import cookiesModifier from "../../utils/cookies";

const useSignIn = () => {

    const mutationFn = async (data:any) => {
        return await signIn(data.payload);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessRunning(true);
        },
        onSuccess: (response, variables) => {
            if (response?.data) {
                console.log(process.env.REACT_APP_ADMIN_TOKEN)
                cookiesModifier.setCookie(process.env.REACT_APP_ADMIN_TOKEN as string, response.data, (365 * 24 * 60 * 60 * 1000));
                variables.setServiceError(null);
                variables.callback();
            } else {
                variables.setServiceError('Oops! Something went wrong, please try again.');
            }
        },
        onError: (error:any, variables) => {
            if (error?.response?.status === 400 && error?.response?.data?.includes('User does not exist')) {
                variables.setServiceError('User does not exist!');
            } else if (error?.response?.status === 401) {
                variables.setServiceError('Wrong password!');
            } else {
                variables.setServiceError('Oops! Something went wrong, please try again.');
            }
        },
        onSettled: (data, error, variables) => {
            variables.setIsProcessRunning(false);
        }
    });
};

export default useSignIn;

